import { Search, X } from "lucide-react";

export default function SearchInput({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  size = "sm",
  className = "",
  isRetailerMobile = false, // ✅ ADD THIS
}) {
  return (
    <div
      className={`flex items-center gap-2 px-3 rounded-xl transition-all duration-300
      ${
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border border-white/30 focus-within:ring-2 focus-within:ring-white/40"
          : "border border-slate-200 bg-slate-50 focus-within:ring-2 focus-within:ring-blue-200"
      }
      ${size === "sm" ? "h-9" : "h-8"} ${className}`}
    >
      {/* Search Icon */}
      <Search
        className={`w-4 h-4 shrink-0 ${
          isRetailerMobile ? "text-black/70" : "text-slate-700"
        }`}
      />

      {/* Input */}
      <input
        type="text"
        placeholder={placeholder}
        className={`flex-1 h-full bg-transparent outline-none text-sm
          ${
            isRetailerMobile
              ? "text-black placeholder:text-black/60"
              : "placeholder:text-slate-500"
          }`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      {/* Clear Button */}
      {value && (
        <button
          type="button"
          onClick={onClear}
          className={`flex items-center justify-center w-6 h-6 rounded-md transition
            ${
              isRetailerMobile
                ? "text-black/70 hover:bg-white/20"
                : "text-slate-500 hover:text-slate-700 hover:bg-slate-200"
            }`}
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}




// import { Search, X } from "lucide-react";

// export default function SearchInput({
//   value,
//   onChange,
//   onClear,
//   placeholder = "Search...",
//   size = "sm",          // "sm" | "md"
//   className = "",
// }) {
//   return (
//     <div
//       className={`flex items-center gap-1 px-3 py-1 rounded-xl border border-slate-200 
//       bg-slate-50 focus-within:ring-2 focus-within:ring-blue-200 ${className}`}
//     >
//       <Search className="w-4 h-4 text-slate-800" />

//       <input
//         type="text"
//         placeholder={placeholder}
//         className={`bg-transparent outline-none placeholder:text-slate-700
//           ${size === "sm" ? "text-xs w-40" : "text-sm w-56 sm:w-64"}`}
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//       />

//       {value && (
//         <button
//           type="button"
//           onClick={onClear}
//           className="ml-1 text-slate-500 hover:text-slate-700"
//         >
//           <X className="w-3.5 h-3.5" />
//         </button>
//       )}
//     </div>
//   );
// }
